import Vue from 'vue'
import 'normalize.css/normalize.css' // A modern alternative to CSS resets
import locale from 'element-ui/lib/locale/lang/zh-CN' // lang i18n
// i-view 组件
import iView from 'iview';  //ui
import { Notice,Message } from 'iview'; //iview提示
import 'iview/dist/styles/iview.css';
import ElementUI from 'element-ui'//ui
import 'element-ui/lib/theme-chalk/index.css'
import '@/styles/index.scss' // global css
import '@/styles/style.scss'
import App from './App'
import store from './store'
import router from './router'
import VueCookie from 'vue-cookie';
// import BaiduMap from 'vue-baidu-map'    //引入百度地图所有api
import '@/icons' // icon
import Vuex from 'vuex'//使用vuex插件
import '@/permission' // permission control
// import BMap from 'BMap'   //全局注册，
import './utils/directive.js'//窗口拖动工具
import axios from 'axios' //暴露axios
import VueUeditorWrap from 'vue-ueditor-wrap' // ES6 Module
Vue.prototype.$axios = axios
import uploader from 'vue-simple-uploader'  //基于vue-simple-uploader封装全局上传组件
import cd from '@/utils/cdUtils/room'
import clklog from './utils/clklog'; // 引入刚才封装的工具类

clklog.init({
  server_url: 'https://app-api.yazhou-bay.com/clklog/receiver/api/gp?project=purchase_user_web&token=20002d23-434f-4f5a-bef7-0959f40129d5',
  is_track_single_page:true, // 单页面配置，默认关闭。开启后自动监听 URL 有变化就会触发 $pageview 事件
  use_client_time:true, 
  send_type:'beacon',
  heatmap: {
    //是否开启点击图，default 表示开启，自动采集 $WebClick 事件，可以设置 'not_collect' 表示关闭。
    clickmap:'default',
    //是否开启触达图，not_collect 表示关闭，不会自动采集 $WebStay 事件，可以设置 'default' 表示开启。
    scroll_notice_map:'not_collect'
  }
})

//iview提示及提示位置
Vue.prototype.$Message = Message
Vue.prototype.$Notice = Notice
Vue.prototype.cd = cd;

Vue.prototype.$Notice.config({
  top: 300,
  duration: 3
});
Vue.prototype.$Message.config({
  top: 300,
  duration: 3
});

Vue.use(uploader)

//+++++++++++++++++++++++++++++++++++++++++++++++++++

Vue.component('vue-ueditor-wrap', VueUeditorWrap)
// Vue.use(BaiduMap, {
//   ak: '712kqWzGk4MENiR98xWp5fDoaKcGNqwg'    //这个地方是官方提供的ak密钥
// })
Vue.use(ElementUI, { locale })
Vue.use(VueCookie)
Vue.config.productionTip = false
Vue.use(iView);
Vue.use(Vuex);

new Vue({
  // BMap,
  el: '#app',
  router,
  store,
  render: h => h(App)
})
if (module.hot) {
  module.hot.accept();
}



// WEBPACK FOOTER //
// ./src/main.js